import ContextPanel from "../../../global/components/ContextPanel/ContextPanel.vue";
import InstrumentvariantenBasisdaten from "./InstrumentvariantenBasisdaten/InstrumentvariantenBasisdaten.vue";
import PuxPageDetails from "../../../global/components/PuxPageDetails/PuxPageDetails.vue";
import PuxTranslate from "../../../global/components/PuxTranslate/PuxTranslate.vue";

import HttpAPI from "../../../global/compositionAPI/HttpAPI";

// @vue/component
export default {
  name: "InstrumentvariantenDetails",
  components: {
    ContextPanel,
    InstrumentvariantenBasisdaten,
    PuxPageDetails,
    PuxTranslate,
  },
  setup() {
    const {
      getHttp,
    } = HttpAPI();

    return {
      getHttp,
    };
  },
  data() {
    return {
      loading: true,
      variante: {},
      panelOptions: {
        label: "_LBL_INSTRUMENTVARIANTE_",
        icon: "glyphicon-file",
        active: true,
      },
    };
  },
  computed: {
    varianteUrl() {
      return `foerderinstrumentvarianten/${ this.$stateParams.id }/`;
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.getHttp({
        url: this.varianteUrl,
      }).then(
        response => {
          this.variante = response;
        }
      ).then(
        () => this.loading = false
      );
    },

    updateVariante({ variante }) {
      this.variante = variante;
    },
  },
};
